import { Api } from "@open-revenue/schema/api-schema";
import { StripeApi } from "@open-revenue/stripe/schema";
export const OpenRevenueApi = Api.add(StripeApi.StripeApi).prefix("/open-revenue/dash-api");
